module.exports = __webpack_public_path__ + "img/user_rect.e47a54b3.png";